module.exports = __webpack_public_path__ + "img/cf_green.00d82be1.svg";